export const InsuranceVI = {
    "employeeInsurance": {
        "breadCrumb": {
            "insuranceIncrease": "Danh sách tăng dự kiến tháng",
            "insuranceDecrease": "Danh sách giảm dự kiến tháng",
            "insurancePayment": "Danh sách đóng bảo hiểm tháng",
            "insuranceHistory": "Lịch sử đóng bảo hiểm năm"
        },
        "title": {
            "generalInformation": "Thông tin chung",
            "increaseMajor": "Nghiệp vụ báo tăng",
            "decreaseMajor": "Nghiệp vụ báo giảm",
            "insurancePaymentHistories": "Lịch sử đóng bảo hiểm",
            "regimeSolveHistories": "Lịch sử giải quyết chế độ"
        },
        "label": {
            "socialInsuranceCode": "Số sổ BHXH",
            "state": "Trạng thái sổ",
            "department": "Pháp nhân đóng",
            "healthInsuranceCode": "Số thẻ BHYT",
            "province": "Mã tỉnh cấp",
            "healthFacility": "Đăng kí khám chữa bệnh",
            "incEmployeeCompleteProfileDate": "NV hoàn thiện HS",
            "incHumanResourceCompleteProfileDate": "NS hoàn thiện HS",
            "incReceiveHealthInsuranceCardDate": "Ngày nhận thẻ BHYT",
            "incReturnHealthInsuranceCardDate": "Ngày trả thẻ BHYT",
            "decReceiveInsuranceBookDate": "Ngày nhận sổ BH từ NLĐ",
            "decHumanResourceCompleteProfileDate": "NS hoàn thiện HS",
            "decReceiveClosedInsuranceBookDate": "Ngày nhận số BH đã chốt",
            "decReturnInsuranceBookDate": "Ngày trả sổ cho NLĐ",
            "confirmDate": "Ngày chốt",
            "fromMonth": "Từ tháng",
            "formality": "Hình thức",
            "increaseFormality": "Báo tăng",
            "decreaseFormality": "Báo giảm",
            "reason": "Lý do",
            "insuranceAmount": "Mức đóng bảo hiểm",
            "companyAmount": "CTY đóng",
            "employeeAmount": "NLĐ đóng",
            "regimeType": "Loại chế độ",
            "receiveProfileDate": "Ngày nhận hồ sơ",
            "procedureCompleteDate": "Ngày hoàn thiện thủ tục",
            "receiveInsuranceMoneyDate": "Ngày nhận tiền BH trả",
            "returnRegimeMoneyDate": "Ngày trả chế độ",
            "regimeAmount": "Số tiền",
            "count": "Lần",
            "TT": "TT",
            "all": "Tất cả"
        },
        "placeHolder": {
            "socialInsuranceCode": "Nhập số sổ BHXH",
            "state": "Chọn trạng thái",
            "department": "Chọn pháp nhân",
            "healthInsuranceCode": "Nhập số thẻ BHYT",
            "province": "Chọn mã tỉnh",
            "healthFacility": "Chọn nơi khám",
            "formality": "Chọn hình thức",
            "reason": "Chọn lý do",
            "confirmDate": "Nhập ngày",
            "amount": "Nhập số tiền",
            "regimeType": "Chọn chế độ"
        },
        "message": {
            "incCompleteDateException": "Ngày nhân sự hoàn thiện hồ sơ không được trước ngày nhân viên hoàn thiện hồ sơ",
            "incReturnDateException": "Ngày trả thẻ BHYT không được trước ngày nhận thẻ BHYT",
            "decCompleteDateException": "Ngày nhân sự hoàn thiện hồ sơ không được trước ngày nhận sổ BH từ NLĐ",
            "decReturnDateException": "Ngày trả sổ BHXH không được trước ngày nhận sổ BH đã chốt",
            "procedureCompleteDateException": "Ngày hoàn thiện thủ tục không được trước ngày nhận hồ sơ",
            "receiveInsuranceMoneyDateException": "Ngày nhận tiền BH trả không được trước ngày hoàn thiện thủ tục",
            "returnRegimeMoneyDateException": "Ngày trả chế độ không được trước ngày hoàn thiện thủ tục",
            "add": "Thêm thành công",
            "update": "Cập nhật thành công",
            "error": "Lỗi",
            "duplicateInsurancePaymentHistoryInMonth": "Trong 1 tháng không thể có 2 hình thức báo tăng hoặc giảm",
            "conflictInsurancePaymentHistoryInMonth": "Xung đột về ngày chốt của các hình thức báo tăng giảm trong tháng",
            "titleConfirm": "Chốt bảo hiểm",
            "confirmContent": "Bạn có muốn chốt bảo hiểm này không?",
            "titleCancelConfirm": "Hoàn chốt bảo hiểm",
            "cancelConfirmContent": "Bạn có muốn hoàn chốt bảo hiểm này không?",
            "confirm": "Chốt thành công",
            "cancelConfirm": "Hoàn chốt thành công",
            "required": {
                "formality": "Vui lòng chọn hình thức",
                "fromMonth": "Vui lòng chọn tháng",
                "employeeInsuranceRate": "Vui lòng nhập ít nhất 1 loại bảo hiểm",
                "insuranceCompanyRate": "Tỷ lệ bảo hiểm công ty trả không được lớn hơn tỷ lệ bảo hiểm chung",
                "duplicateInsuranceRate": "Không thể có hai tỉ lệ bảo hiểm trong cùng một tháng"
            }
        }
    },
    "insuranceSider": {
        "headingLabel": "Bảo hiểm",
        "listInsurancePayment": "Tất cả",
        "listInsuranceIncrease": "Tăng dự kiến",
        "listInsuranceDecrease": "Giảm dự kiến",
        "listInsuranceHistory": "Lịch sử đóng"
    },
    "insuranceColumns": {
        "employeeCode": "Mã NV",
        "employeeName": "Họ và tên",
        "department": "Phòng ban",
        "jobPosition": "Vị trí công việc",
        "jobTitle": "Chức vụ",
        "socialInsuranceCode": "Số sổ",
        "healthInsuranceCode": "Số thẻ",
        "fromMonth": "Bắt đầu đóng",
        "amount": "Mức đóng bảo hiểm",
        "companyAmount": "CTY đóng",
        "employeeAmount": "NLĐ đóng",
        "reason": "Lý do",
        "confirm": "Chốt",
        "notConfirm": "Chưa chốt",
        "cancelConfirm": "Hoàn chốt",
        "STT": "STT",
        "month": "Tháng",
        "obligateAmount": "Phải đóng",
        "payment": "Đã đóng",
        "sum": "Tổng"
    }
}